import React from 'react';

import { type BlogMeta, WhatsNewArticle } from '@af/design-system-docs-ui';

import Content from './_assets/content.mdx';
import header from './_assets/header.png';

export const meta: BlogMeta = {
	title: 'Evolving buttons and links',
	author: 'Written by the Design System Team',
	description:
		"Explore how we've revamped our button and link components to be more accessible, performant, and consistent.",
	image: header,
	publishDate: new Date(2025, 2, 18),
	readTime: '5 min read',
	type: 'Feature deep dive',
	href: '/whats-new/evolving-button-and-links',
};

export default () => {
	return <WhatsNewArticle meta={meta} content={<Content />} />;
};
